import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { BUSINESS_INVOICE_HISTORY_WRAPPER, BUSINESS_INVOICE_LIST, BUSINESS_INVOICE_PAYMENT_LIST, BUSINESS_INVOICE_PAYMENT_WRAPPER, BUSINESS_INVOICE_WRAPPER } from "../Business.constants";

const BusinessInvoiceList = Loadable(
  lazy(() =>
    import(
      "./BusinessInvoiceTabs"
    ).then(({ BusinessInvoiceTabs }) => ({
      default: BusinessInvoiceTabs,
    }))
  )
);
const BusinessInvoiceHistoryWrapper = Loadable(
  lazy(() =>
    import(
      "./BusinessInvoiceHistoryWrapper"
    ).then(({ BusinessInvoiceHistoryWrapper }) => ({
      default: BusinessInvoiceHistoryWrapper,
    }))
  )
);
const BusinessInvoiceWrapper = Loadable(
  lazy(() =>
    import(
      "./BusinessInvoice"
    ).then(({ BusinessInvoiceWrapper }) => ({
      default: BusinessInvoiceWrapper,
    }))
  )
);
const BusinessBulkInvoiceWrapper = Loadable(
  lazy(() =>
    import(
      "./BusinessBulkInvoiceWrapper"
    ).then(({ BusinessBulkInvoiceWrapper }) => ({
      default: BusinessBulkInvoiceWrapper,
    }))
  )
);
const BusinessInvoicePaymentList = Loadable(
  lazy(() =>
    import(
      "./BusinessInvoicePaymentList"
    ).then(({ BusinessInvoicePaymentList }) => ({
      default: BusinessInvoicePaymentList,
    }))
  )
);
const BusinessInvoicePaymentWrapper = Loadable(
  lazy(() =>
    import(
      "./BusinessInvoicePaymentWrapper"
    ).then(({ BusinessInvoicePaymentWrapper }) => ({
      default: BusinessInvoicePaymentWrapper,
    }))
  )
);
export const InvoicesRoutes = [
  {
    path: `${BUSINESS_INVOICE_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoiceList />
      </AuthorizedRoute>
    ),
  },
  {
    path:  `${BUSINESS_INVOICE_HISTORY_WRAPPER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoiceHistoryWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path:  `${BUSINESS_INVOICE_WRAPPER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoiceWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path:  `${BUSINESS_INVOICE_WRAPPER}/:invoiceId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoiceWrapper />
      </AuthorizedRoute>
    ),
  },
   {
    path:  `/business-policy/:customerId/invoices/:customerPolicyId/bulk-invoice`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessBulkInvoiceWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path:  `${BUSINESS_INVOICE_PAYMENT_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoicePaymentList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${BUSINESS_INVOICE_PAYMENT_WRAPPER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoicePaymentWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/invoices/:customerPolicyId/bulk-payment`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInvoicePaymentWrapper />
      </AuthorizedRoute>
    ),
  },
];
